import React, { FC } from 'react';
import styles from './ImeiRetry.module.css';
import Step from '../Steps/Step/Step';
import { Page, StepType } from '../../state/types';
import Button from '../Button/Button';
import { useState } from '../../state/store';
import FormContainer from '../FormContainer/FormContainer';

interface ImeiRetryProps {}

const ImeiRetry: FC<ImeiRetryProps> = () => {
  const { dispatch } = useState();
  const retry = () => dispatch('retryImei');
  return (
    <Step stepToShow={StepType.NewDeviceCheck}>
      <div className={styles.ImeiRetry} data-testid="ImeiRetry">
        <div className="w-full bg-gray-100 rounded">
          <FormContainer header={'Wrong IMEI'}>
            <div className={'p-2 text-center italic text-2xl'}>
              It is not possible to validate your new device IMEI.
            </div>
            <div className={'p-2 text-center'}>Ensure you are inserting the IMEI of your new Samsung device.</div>
            <div className={'p-2 text-center font-bold'}>How to retrieve the IMEI of your NEW device.</div>
            <div className={'p-2 text-center'}>
              <p>
                Dial <strong>*#06#</strong> from your device.
              </p>
              <p>An IMEI is 15 characters long, please verify the IMEI of your new phone and Try Again.</p>
            </div>
            <div className={'p-2 text-center'}>
              <p>
                Alternatively, Go to <strong>Settings</strong>, Select <strong>About phone</strong> or{' '}
                <strong>About device</strong>
              </p>
            </div>
            <div className={'p-2 text-center'}>
              <Button onClick={retry}>Try again</Button>
            </div>
            <div className={'p-2 text-center italic'}>
              If the issue still persists and you are inserting the correct IMEI of your new device and you retrieve
              this message, your device may have not been registered yet for the service.
            </div>
            <div className={'p-2 text-center'}>
              We kindly ask you to please try again in the next 24 hours or alternatively please{' '}
              <a href={`#${Page.ContactUs}`}>Contact Us</a>.
            </div>
          </FormContainer>
        </div>
      </div>
    </Step>
  );
};

export default ImeiRetry;
